import React, {useEffect} from 'react';
// import {useNavigate} from 'react-router-dom';
// import { Redirect } from '@shopify/app-bridge/actions';
// import { useAppBridge } from '@shopify/app-bridge-react';

const Home = () => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const shop = urlParams.get("shop");
    console.log("i m home!!", shop);
    const shopName = shop?.split(".")[0]
    useEffect(()=>{
        window.top.location.href = `https://admin.shopify.com/store/${shopName}/apps/${process.env.REACT_APP_NAME}/settings?shop=${shop}`
    },[])
    return (<h1></h1>)
};

export default Home;
